import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PrimeiroAcessoComponent } from './primeiro-acesso.component';
import { PrimeiroAcessoRoutingModule } from './primeiro-acesso-routing.module';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { AppConfigModule } from 'src/app/layout/config/app.config.module';
import {InputMaskModule} from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormatPipeModule } from '../../format-pipe/format-pipe.module';


@NgModule({
    imports: [
        CommonModule,
        PrimeiroAcessoRoutingModule,
        FormsModule,
        ButtonModule,
        RippleModule,
        InputTextModule,
        CheckboxModule,
        AppConfigModule,
        InputMaskModule,
        MessagesModule,
        RadioButtonModule,
        FormatPipeModule
    ],
    declarations: [PrimeiroAcessoComponent]
})
export class PrimeiroAcessoModule { }
